import { render, staticRenderFns } from "./gymDeadLift.vue?vue&type=template&id=fe6811c8&"
import script from "./gymDeadLift.js?vue&type=script&lang=js&"
export * from "./gymDeadLift.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports